export enum AppointmentConfirmationStatus {
  Unconfirmed = 'unconfirmed',
  Confirmed = 'confirmed',
  ChangeRequested = 'change_requested',
  SignerUnreachable = 'signer_unreachable'
}
